import { observer } from 'mobx-react'
import React from 'react'
import { Block, Heading } from 'suomifi-ui-components'
import LocalizedString, {
  LocalizedParagraphs,
} from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'

const AetSummaryDeliveryMethod: React.FC = observer(() => {
  return (
    <Block variant="section">
      <Heading variant="h3">
        <LocalizedString stringKey="aetSummaryDeliveryMethodTitle" />
      </Heading>
      <LocalizedParagraphs stringKey="aetSummaryDeliveryMethodDescription_paragraphs" />
    </Block>
  )
})

export default AetSummaryDeliveryMethod
